import { defineComponent as _defineComponent } from 'vue'
import { useGenerateIds } from '../composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'label-box',
  props: {
    id: null,
    name: null,
    label: { type: [String, Boolean] },
    labelClass: null,
    controlClass: null,
    plain: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    id?: string;
    name?: string;
    label?: string | boolean;
    labelClass?: string;
    controlClass?: string;
    plain?: boolean;
}

const generateIds = useGenerateIds();

//simulate old {% box %} macro, but only handle either both classes (horizontal) or none (vertical, inline)

const controlId = props.id || generateIds();
const controlName = props.name || controlId;


return { __sfc: true,generateIds, props, controlId, controlName }
}

})